import { render, staticRenderFns } from "./teamZZtable.vue?vue&type=template&id=62879dc0&scoped=true"
import script from "./teamZZtable.vue?vue&type=script&lang=js"
export * from "./teamZZtable.vue?vue&type=script&lang=js"
import style0 from "./teamZZtable.vue?vue&type=style&index=0&id=62879dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62879dc0",
  null
  
)

export default component.exports